import { HEALTH_STATUS } from '@/const';

export const DEFAULT_FAULT_TYPE = 'Early Condition Monitoring';

export type WorkOrder = {
  wo_id: string;
  wo_reference: string;
  source: string;
  status: 'created' | string;
  created_at: string;
  scheduled_date: string | null;
  completed_at: string | null;
  assigned_to: string | null;
  notes: string | null;
};

export type Fault = {
  fault_id: string;
  fault_logical_id: string;
  location: {
    asset_id: string;
    asset_name: string;
    asset_ui_name: string;
    component_id: string;
    component_name: string;
    component_ui_name: string;
    unit_ui_name: string | null;
    asset_area: string | null;
    asset_type: string | null;
  };
  fault_type: {
    fault_type_id: string;
    name: string;
    category: string | null;
    description: string | null;
  };
  status: {
    status: 'open' | 'closed' | string;
    status_changed_at: string;
    status_changed_by: string;
    previous_status: string | null;
  };
  health_status: HEALTH_STATUS;
  timing: {
    start_date: string;
    last_updated: string;
    resolved_at: string | null;
    days_open: number;
    validation_date: string | null;
  };
  evidence: {
    evidence_data: {
      text: string;
      resource_id: string | null;
    }[];
    possible_causes: string[];
    prescriptive_actions: string[];
    maintenance_reference: string | null;
    remarks:
      | {
          text: string;
          background_color: string;
          text_color?: string;
          order?: number;
        }[]
      | null;
  };
  source: {
    diagnostic_count: number;
    first_diagnostic_id: string;
    latest_diagnostic_id: string;
    diagnostic_ids: string[];
  };
  diagnostics: any | null;
  assignee: string | null;
  work_orders: WorkOrder[];
  activities: any[];
  is_verified: boolean;
  verification_date: string | null;
  created_by: string;
  debug: {
    description: string;
    algorithm_trace: string;
    diagnostic_summary: string;
    merge_info: string | null;
  };
};

export type FaultData = {
  faults: Fault[];
  summary: any;
};

export interface FaultsResponse {
  open_faults: Fault[];
  summary: any;
}

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
